import { render } from "./FormClient.vue?vue&type=template&id=60868c8e&scoped=true"
import script from "./FormClient.vue?vue&type=script&lang=js"
export * from "./FormClient.vue?vue&type=script&lang=js"

import "./FormClient.vue?vue&type=style&index=0&id=60868c8e&scoped=true&lang=scss"

import exportComponent from "D:\\Source\\mobaxe\\mobaxe.docs.app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60868c8e"]])

export default __exports__